import { apimapSlice } from "@/redux/app/api/apiSlice";

export const mapApiSlice = apimapSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllMapLocations: builder.query({
      query: (params) => ({
        url: `/api/filter/university-map-links`,
        params: { ...params },
      }),
      providesTags: ["map"],
    }),
  }),
});

export const { useGetAllMapLocationsQuery } = mapApiSlice;
